<div class="modal">
  <div class="modal-overlay" (click)="cancel($event)"></div>

  <div class="modal-dialog" role="document">
    <div class=" modal-content">

      <div class="modal-header">
        <span class="modal-title">{{ modalTitle }}</span>
        <span class="me-auto"></span>
        <i class="btn btn-danger bi bi-x-lg" (click)="cancel($event)"></i>
      </div>

      <div class="modal-body">
        <form id="userInformationSetDialog" class="m-3">

          @if (userCopy) {
            <div class="form-floating">
              <input class="form-control" type="text" disabled [value]="userCopy.coUserNumber" placeholder=""
                name="coUserNumberInputField" (change)="userCopy.coUserNumber = userCopy.coUserNumber?.trim()">
              <label i18n="@@UserInformationSetcoUserNumberInputLabel">CoUserNumber</label>
            </div>
            <div class="form-floating mt-2">
              <input class="form-control" type="text" disabled [value]="userCopy.salutation | eSalutationToOptionString"
                placeholder="" name="nameInputField" (change)="userCopy.salutation = userCopy.salutation?.trim()">
              <!-- <select class="form-select" [ngModel]="userCopy.salutation" disabled name="salutationSelect"
              id="salutationSelect">
              <option [value]="userCopy.salutation" selected>{{ userCopy.salutation | eSalutationToOptionString }}</option>
            </select> -->
            <label for="salutationSelect" i18n="@@UserInformationSetSalutationSelectLabel">Salutation</label>
          </div>
          <div class="form-floating mt-2">
            <input class="form-control" type="text" disabled [value]="userCopy.firstName" placeholder=""
              name="nameInputField" (change)="userCopy.firstName = userCopy.firstName?.trim()">
            <label i18n="@@UserInformationSetNameInputLabel">Name</label>
          </div>
          <div class="d-flex flex-nowrap">
            @if (selectedCountryCode != undefined && countryList != undefined && countryList.length > 0) {
              <div
                class="form-floating mt-2">
                <app-country-combo-box [countryList]="countryList" [selectedCountry]="selectedCountry"
                (valueChanged)="onCountryCodeChange($event)"></app-country-combo-box>
              </div>
            }
            <div class="form-floating mt-2 w-100">
              <input class="form-control" type="text" [class.is-invalid]="userCopy.mobile && !isValidMobileNumber()"
                [ngClass]="getMobileInputClass()" [(ngModel)]="userCopy.mobile" placeholder=""
                name="MobileNumberInputField" (input)="onInputChange()"
                (change)="userCopy.mobile = userCopy.mobile?.trim()">
              <label class="countryComboboxLabel" i18n="@@UserInformationSetMobileNumberInputLabel">Mobil</label>
            </div>
          </div>
          <div class="form-floating mt-2">
            <input class="form-control" type="text" [class.is-invalid]="userCopy.eMail && !isValidMail()"
              [ngClass]="getMailInputClass()" [(ngModel)]="userCopy.eMail" placeholder="" required
              name="eMailInputField" (change)="userCopy.eMail = userCopy.eMail?.trim()">
            <label i18n="@@UserInformationSetEMailInputLabel">E-Mail</label>
          </div>
          <div class="ms-2 mt-2 newsletter">
            <app-check-newsletter [isChecked]="userCopy.newsletterSubscribed"
            (onChecked)="userCopy.newsletterSubscribed = $event"></app-check-newsletter>
          </div>
        }

      </form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-success" data-bs-dismiss="modal" (click)="submitAsync($event)">{{
      submitButtonLabel }}</button>
      <button type="button" class="btn btn-warning" data-bs-dismiss="modal" (click)="cancel($event)">{{
      cancelButtonLabel }}</button>
    </div>

  </div>
</div>
</div>